import { useState } from "react";
import { Button } from "components/DesignSystem/Button/Button";
import { CheckoutModal } from "components/CheckoutModal/CheckoutModal";
import { useToast } from "hooks/useToast";
import { BackendError } from "types/utils/error";
import { useDispatch } from "react-redux";
import { fillings } from "store/apis/filing";
import { BaseTaskOverview, Task } from "types/Models/task";
import { stateUpdate } from "apis/stateUpdate";
import { FILING_IN_PROGRESS, FORM_FILING } from "constants/taskStates";
import { stopPropagation } from "utils/stopPropagation";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { CUSTOMER_PAYER, FCA_PAYER } from "constants/payer";

export const PayForUnpaidTask = ({
  task,
  finalPrice,
  onPayClick,
}: {
  task: BaseTaskOverview;
  finalPrice: number | string;
  onPayClick?: () => void;
}) => {
  const { isForeignCA } = useRoleBasedView();
  const { alertToast } = useToast();
  const [isPaymentModalOpen, setPaymentModalOpen] = useState(false);
  const dispatch = useDispatch();
  const formFilingStateUuid = task.task_states.find(
    (state) => state.type_str === FORM_FILING
  )?.uuid;
  const filingInProgressStateUuid = task.task_states.find(
    (state) => state.type_str === FILING_IN_PROGRESS
  )?.uuid;

  const next = formFilingStateUuid || filingInProgressStateUuid;

  const updateState = async () => {
    try {
      if (next) {
        await stateUpdate({ taskId: task.task_uuid, id: next });
      }
    } catch (e: any) {
      alertToast({ message: e?.response?.data?.error?.message });
    }
  };

  const openPaymentModal = async (e: React.MouseEvent<HTMLButtonElement>) => {
    try {
      onPayClick?.();
      setPaymentModalOpen(true);
    } catch (error: any) {
      alertToast({ message: (error as BackendError).data?.error?.message });
    }
  };

  const closePaymentModal = () => {
    setPaymentModalOpen(false);
  };

  const onPaymentSuccess = () => {
    updateState();
    dispatch(fillings.util.invalidateTags([{ type: "TaskList" }]));
    closePaymentModal();
  };

  return (
    <div onClick={stopPropagation}>
      <Button onClick={openPaymentModal} size="xsmall">
        Pay ${finalPrice}
      </Button>

      {isPaymentModalOpen && (
        <CheckoutModal
          payerUserType={isForeignCA ? FCA_PAYER : CUSTOMER_PAYER}
          type="task"
          task={{ ...task, uuid: task.task_uuid } as unknown as Task}
          open={isPaymentModalOpen}
          onInvoicePaid={onPaymentSuccess}
          onClose={closePaymentModal}
        />
      )}
    </div>
  );
};
